import './App.css';
import AxiosData from './components/AxiosData';


function App() {
	return (
		<div className="App">
		  <AxiosData />
		</div>
	);
}

export default App;
